import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format bytes to human readable string
 * @param bytes Number of bytes
 * @param decimals Number of decimal places
 * @returns Formatted string (e.g. "1.5 KB")
 */
export function formatBytes(bytes: number, decimals: number = 2): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
}

export function filterNonNullValues<T extends Record<string, unknown>>(input: T): Partial<T> {
  return Object.fromEntries(
      Object.entries(input).filter(([_, value]) => 
          value !== null && 
          !(Array.isArray(value) && value.length === 0) && 
          !(typeof value === 'object' && value !== null && Object.keys(value).length === 0)
      )
  ) as Partial<T>;
}